import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Save, X, Plus, Trash2 } from 'lucide-react';

const QuizForm = ({
 quizForm,
 setQuizForm,
 newQuestion,
 setNewQuestion,
 onSave,
 onCancel,
 onAddQuestion,
 onRemoveQuestion
}) => {
 return (
 <Card className="mb-6">
 <CardHeader>
 <CardTitle>Create Quiz for Lesson</CardTitle>
 </CardHeader>
 <CardContent>
 <div className="space-y-4">
 <div>
 <Label>Quiz Title</Label>
 <Input
 value={quizForm.title}
 onChange={(e) => setQuizForm({ ...quizForm, title: e.target.value })}
 placeholder="Lesson Quiz"
 />
 </div>
 <div>
 <Label>Description (optional)</Label>
 <Input
 value={quizForm.description}
 onChange={(e) => setQuizForm({ ...quizForm, description: e.target.value })}
 placeholder="Test your knowledge..."
 />
 </div>
 <div>
 <Label>Passing Score (%)</Label>
 <Input
 type="number"
 value={quizForm.passing_score}
 onChange={(e) => setQuizForm({ ...quizForm, passing_score: parseInt(e.target.value) })}
 min="0"
 max="100"
 />
 </div>

 <div className="border-t pt-4">
 <h4 className="font-semibold mb-3">Questions ({quizForm.questions.length})</h4>
 
 {/* Existing Questions */}
 {quizForm.questions.map((q, index) => (
 <div key={index} className="p-3 bg-slate-50 dark:bg-slate-800 rounded-lg mb-2 flex items-start justify-between">
 <div className="flex-1">
 <p className="font-medium">{index + 1}. {q.question}</p>
 <p className="text-sm text-slate-600 dark:text-neutral-400">Correct: {q.correct_answer}</p>
 </div>
 <Button
 size="sm"
 variant="ghost"
 onClick={() => onRemoveQuestion(index)}
 className="text-red-600"
 >
 <Trash2 className="w-4 h-4" />
 </Button>
 </div>
 ))}

 {/* Add New Question */}
 <div className="border-t pt-4 mt-4 space-y-3">
 <h4 className="font-semibold">Add New Question</h4>
 <div>
 <Label>Question</Label>
 <Input
 value={newQuestion.question}
 onChange={(e) => setNewQuestion({ ...newQuestion, question: e.target.value })}
 placeholder="What is freeze drying?"
 />
 </div>
 <div>
 <Label>Question Type</Label>
 <select
 value={newQuestion.type}
 onChange={(e) => setNewQuestion({ ...newQuestion, type: e.target.value })}
 className="w-full p-2 border rounded-lg"
 >
 <option value="multiple_choice">Multiple Choice</option>
 <option value="true_false">True/False</option>
 <option value="short_answer">Short Answer</option>
 </select>
 </div>
 
 {newQuestion.type === 'multiple_choice' && (
 <div>
 <Label>Options (one per line)</Label>
 <textarea
 value={newQuestion.options.join('\n')}
 onChange={(e) => setNewQuestion({ 
 ...newQuestion, 
 options: e.target.value.split('\n') 
 })}
 placeholder="Option 1\nOption 2\nOption 3\nOption 4"
 className="w-full p-2 border rounded-lg min-h-[100px]"
 />
 </div>
 )}
 
 <div>
 <Label>Correct Answer</Label>
 <Input
 value={newQuestion.correct_answer}
 onChange={(e) => setNewQuestion({ ...newQuestion, correct_answer: e.target.value })}
 placeholder="The correct answer"
 />
 </div>
 <div>
 <Label>Explanation (optional)</Label>
 <textarea
 value={newQuestion.explanation}
 onChange={(e) => setNewQuestion({ ...newQuestion, explanation: e.target.value })}
 placeholder="Explain why this is the correct answer..."
 className="w-full p-2 border rounded-lg min-h-[60px]"
 />
 </div>
 
 <Button
 onClick={onAddQuestion}
 variant="outline"
 className="w-full bg-blue-600 hover:bg-blue-700 text-white"
 >
 <Plus className="w-4 h-4 mr-2" />
 Add Question
 </Button>
 </div>
 </div>

 <div className="flex gap-3 mt-4">
 <Button onClick={onSave} className="bg-amber-600 hover:bg-amber-700">
 <Save className="w-4 h-4 mr-2" />
 Create Quiz
 </Button>
 <Button onClick={onCancel} variant="outline">
 <X className="w-4 h-4 mr-2" />
 Cancel
 </Button>
 </div>
 </div>
 </CardContent>
 </Card>
 );
};

export default QuizForm;
